function cov_2l2hcn5589() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/core/AddressInput/index.ts";
  var hash = "2e617674482a22aeca35155a3708ec77f9e64b42";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/core/AddressInput/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2e617674482a22aeca35155a3708ec77f9e64b42"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2l2hcn5589 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2l2hcn5589();
export { default } from "./AddressInput.mjs";
//# sourceMappingURL=index.mjs.map